import dynamic from 'next/dynamic'

// Lazy load the entire PhoneInput component to reduce bundle size
const PhoneInputImpl = dynamic(() => import('./phone-input-impl'), {
  loading: () => (
    <div className="flex h-12 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
      Loading...
    </div>
  ),
  ssr: false,
})

import * as RPNInput from 'react-phone-number-input'

export type PhoneInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'value'
> &
  Omit<RPNInput.Props<typeof RPNInput.default>, 'onChange'> & {
    onChange?: (value: RPNInput.Value) => void
    clearable?: boolean
    onClear?: () => void
    clearClassName?: string
    defaultCountry?: RPNInput.Country
    fallbackCountry?: RPNInput.Country
  }

export const PhoneInput = PhoneInputImpl
